import React from 'react';
import Alert from '@material-ui/lab/Alert';
import strings from 'strings';
import Text from 'UI/components/atoms/Text';

import { StyledButton } from './StatsInfoAlerts.styled';

const { alerts: alertsCopies } = strings.bulkEmails.stats;

const StatsInfoAlert = ({ message, url }) => (
  <Alert
    severity="info"
    action={
      <StyledButton color="inherit" size="small" href={url} target="_blank" variant="outlined">
        {alertsCopies.learnMoreButton}
      </StyledButton>
    }
  >
    <Text text={message} />
  </Alert>
);

export default StatsInfoAlert;
